// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WalletTwoToneSvg from "@ant-design/icons-svg/es/asn/WalletTwoTone";
import AntdIcon from '../components/AntdIcon';

var WalletTwoTone = function WalletTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WalletTwoToneSvg
  }));
};

WalletTwoTone.displayName = 'WalletTwoTone';
export default React.forwardRef(WalletTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/WalletTwoTone.js
// module id = 2043
// module chunks = 0